var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "tender_data standart_mem" },
    [
      _c("standart", {
        key: "tender_addon",
        attrs: {
          title:
            "Протокол засідання тендерної комісії з проведення процедури розгляду тендерних пропозицій №",
          is_active_result: true,
          is_active_problem: true,
        },
        scopedSlots: _vm._u([
          {
            key: "after_title",
            fn: function () {
              return [
                _c(
                  "b-row",
                  { staticClass: "doc_title" },
                  [
                    _c("b-col", { attrs: { sm: "3" } }, [
                      _c("label", { attrs: { for: "doc_title" } }, [
                        _vm._v("Номер тендеру від Дата тендеру"),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c(
                      "b-col",
                      { attrs: { sm: "4" } },
                      [
                        _c("b-form-input", {
                          staticClass: "fs-xl",
                          attrs: { id: "form_tender_number", size: "sm" },
                          model: {
                            value: _vm.form.number_tender,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "number_tender", $$v)
                            },
                            expression: "form.number_tender",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _vm._v(" "),
      _c(
        "b-container",
        { attrs: { fluid: "" } },
        [
          _c(
            "div",
            { staticClass: "head row-fluid" },
            [
              _vm._l(_vm.addon_fields, function (head) {
                return _c("div", { staticClass: "field", class: head.class }, [
                  _c("div", { staticClass: "title_min" }, [
                    _vm._v(_vm._s(head.name)),
                  ]),
                ])
              }),
              _vm._v(" "),
              _c("div", { staticClass: "clr" }),
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "before_change" },
            [
              _vm._l(_vm.form.rows_standart, function (row, idx) {
                return _c(
                  "div",
                  { staticClass: "action_field row" },
                  [
                    _vm._l(_vm.addon_fields, function (item, idx2) {
                      return _c(
                        "div",
                        { staticClass: "field_insert", class: item.class },
                        [
                          _vm.form.rows_standart[idx][idx2].insert_val !==
                          "numb"
                            ? _c("b-form-input", {
                                attrs: {
                                  readonly:
                                    _vm.form.rows_standart[idx][idx2].is_editor,
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.show_editor(
                                      "standart",
                                      idx,
                                      idx2
                                    )
                                  },
                                },
                                model: {
                                  value:
                                    _vm.form.rows_standart[idx][idx2].value,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.form.rows_standart[idx][idx2],
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "form.rows_standart[idx][idx2].value",
                                },
                              })
                            : _c("div", { staticClass: "np" }, [
                                _vm._v(_vm._s(idx + 1)),
                              ]),
                        ],
                        1
                      )
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "remove_row",
                        on: {
                          click: function ($event) {
                            return _vm.remove_row("standart", idx)
                          },
                        },
                      },
                      [
                        _c("i", {
                          staticClass:
                            "fa fa-trash active color-danger-800 cursor-pointer",
                          attrs: { "aria-hidden": "true" },
                        }),
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "clr" }),
                  ],
                  2
                )
              }),
              _vm._v(" "),
              _c("div", { staticClass: "control title_" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-success",
                    on: {
                      click: function ($event) {
                        return _vm.add_row("standart")
                      },
                    },
                  },
                  [_vm._v("Додати")]
                ),
              ]),
            ],
            2
          ),
          _vm._v(" "),
          _c("div", { staticClass: "pre_title winner" }, [
            _vm._v("\n            Переможець\n        "),
          ]),
          _vm._v(" "),
          _c("b-container", { attrs: { fluid: "" } }, [
            _c(
              "div",
              { staticClass: "after_change" },
              [
                _vm._l(_vm.form.rows_winner, function (row, idx) {
                  return _c(
                    "div",
                    { staticClass: "action_field row" },
                    [
                      _c("div", { staticClass: "np col-1" }, [
                        _vm._v(_vm._s(idx + 1)),
                      ]),
                      _vm._v(" "),
                      _vm._l(_vm.winner_fields, function (item, idx2) {
                        return _c(
                          "div",
                          { staticClass: "field_insert", class: item.class },
                          [
                            _c("b-form-input", {
                              class: _vm.filed_class(
                                _vm.form.rows_winner[idx][idx2]
                              ),
                              attrs: {
                                readonly:
                                  _vm.form.rows_winner[idx][idx2].is_editor,
                                placeholder:
                                  _vm.form.rows_winner[idx][idx2].text,
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.show_editor("winner", idx, idx2)
                                },
                              },
                              model: {
                                value: _vm.form.rows_winner[idx][idx2].value,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.form.rows_winner[idx][idx2],
                                    "value",
                                    $$v
                                  )
                                },
                                expression: "form.rows_winner[idx][idx2].value",
                              },
                            }),
                          ],
                          1
                        )
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "remove_row",
                          on: {
                            click: function ($event) {
                              return _vm.remove_row("winner", idx)
                            },
                          },
                        },
                        [
                          _c("i", {
                            staticClass:
                              "fa fa-trash active color-danger-800 cursor-pointer",
                            attrs: { "aria-hidden": "true" },
                          }),
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "clr" }),
                    ],
                    2
                  )
                }),
                _vm._v(" "),
                _c("div", { staticClass: "control title_" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-success",
                      on: {
                        click: function ($event) {
                          return _vm.add_row("winner")
                        },
                      },
                    },
                    [_vm._v("Додати")]
                  ),
                ]),
              ],
              2
            ),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }